import { set } from 'cerebral/operators'
import { props, state } from 'cerebral/tags'
import getRestrictions from 'utils/getRestrictions'

export default [
  function createForm({ props, state }) {
    const {
      client: { resources: clientResources },
      user: { email }
    } = state.get('app')

    const restrictions = getRestrictions()

    const form = {
      restriction: {
        type: {
          currentRestriction: null
        },
        editModeType: {
          currentRestriction: null,
          tags: restrictions.reduce((acc, item, index) => {
            acc[`${index}`] = {
              label: item.label,
              key: item.key,
              selected: false
            }
            return acc
          }, {})
        },
        email: {
          value: email
        },
        message: {
          value: ''
        }
      },
      resources: clientResources.reduce((acc, resource) => {
        acc[resource] = {}
        acc[resource].form = {
          isForm: true,
          value: '',
          isRequired: true
        }
        return acc
      }, {})
    }

    return {
      form
    }
  },
  set(state`media.tags.form`, props`form`)
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/setSharedTagsForm.js